import { useContext, useEffect, useRef, useState } from 'react';
import { Trans, useLingui } from '@lingui/react/macro';
import { Modal } from 'antd';
import { userContext } from 'contexts/UserContext';
import warningImage from 'images/vendexpert-warning.jpg';

const MESSAGE_SHOWN = 'vendexpert_warning_shown';

export function VendExpertWarningModal() {
  const { t } = useLingui();
  const { user } = useContext(userContext);
  const [isVisible, setIsVisible] = useState(false);
  const shownInSession = useRef(false);

  useEffect(() => {
    if (!user || shownInSession.current) return;

    try {
      if (localStorage.getItem(MESSAGE_SHOWN)) return;
      localStorage.setItem(MESSAGE_SHOWN, 'true');
    } catch {
      // Still show the warning when browser storage is unavailable.
    }

    shownInSession.current = true;
    setIsVisible(true);
  }, [user]);

  if (!user) return null;

  return (
    <Modal
      open={isVisible}
      title={t`Предупреждение об использовании сервиса «ВендЭксперт»`}
      okText={t`Понятно`}
      onOk={() => setIsVisible(false)}
      cancelButtonProps={{ hidden: true }}
      closable={false}
      maskClosable={false}
      keyboard={false}
      width={720}
      centered
      styles={{ body: { maxHeight: '70vh', overflowY: 'auto' } }}
    >
      <Trans>
        <p>
          ООО «Компания ЖВ», являясь производитель вендинговых аппаратов с
          системой GSM-мониторинг, настоящим официально заявляет о следующем.
        </p>
        <p>
          Наша компания не рекомендует сервис «ВендЭксперт», предоставляемый
          Индивидуальным предпринимателем Южаковой Ольгой Алексеевной (ИНН:
          526109523278 ОГРНИП: 325527500150029).
        </p>
        <p>
          ООО «Компания ЖВ» не даёт гарантий сохранения персональных данных и{' '}
          <strong>коммерческой тайны личных кабинетов</strong> при использовании
          данного сервиса.
        </p>
        <p>
          Настоящее предупреждение публикуется в целях защиты интересов наших
          партнёров и клиентов и носит информационный характер.
        </p>
      </Trans>
      <img
        src={warningImage}
        alt={t`ЖВ не рекомендует сервис «ВендЭксперт»`}
        style={{ display: 'block', width: '100%', height: 'auto' }}
      />
    </Modal>
  );
}
